module.exports = __webpack_public_path__ + "static/media/mongodb-original-wordmark.b1847af9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mongodb-original-wordmark.svg
// module id = 98
// module chunks = 0